module.exports = __webpack_public_path__ + "static/media/large-bus.050cd5c2.svg";